import { IFilterOption } from "@phonepe/enigma-ui";
import { TRANSACTION_INSTRUMENTS } from "@shared/constants";

export enum ReportStatus {
	PROCESSING = 'PROCESSING',
	QUEUED = 'QUEUED',
	FAILED = 'FAILED',
	COMPLETED = 'COMPLETED',
	ERRORED = 'ERRORED',
	PENDING = 'PENDING',
}

export interface IStatusBadgeProps {
	status: ReportStatus;
	isPaymentStatus?: boolean;
}

export interface IReportFilters {
	merchantIds: IFilterOption[];
	email: IFilterOption[];
	instruments: IFilterOption[];
	dateRange: IFilterOption[];
	paymentStatus: IFilterOption[];
}
export interface IReportFiltersResponse {
	merchantIds: string[];
	email: string[];
	instruments: string[];
	dateRange: string[];
	status: string[];
}

export interface IFetchReportPayload {
	reportType?: string;
	start: number;
	size?: number;
}

export interface IReportResponse {
	requestId: number;
	jobRequestId: string;
	merchantId: string;
	partnerId: string;
	docStoreId: string;
	state: ReportStatus;
	filters: Partial<IReportFiltersResponse>;
	type: string;
	template: string;
	from: EpochTimeStamp;
	to: EpochTimeStamp;
	userId: string;
	email: string;
	format: string;
	createdAt: EpochTimeStamp;
	updatedAt: EpochTimeStamp;
	targetEntityId: string;
}

export interface IReportData extends Omit<IReportResponse, 'filters' | 'state'> {
	merchantIds: string[];
	instruments: (keyof typeof TRANSACTION_INSTRUMENTS)[];
	paymentStatus: string[];
	reportState: ReportStatus;
}

export interface IReportFiltersPayload {
	merchantIds: string[];
	email: string[];
	instruments: string[];
	status: string[];
	dateRange: string[];
}

export interface IGenerateReportPayload {
	filters?: Partial<IReportFiltersPayload>;
	type: string;
	format: string;
	template?: string;
	reportTemplate?: string;
	reportType?: string;
	from: number;
	to: number;
	emailReceivers: Array<string>;
}
